import React from 'react';
import { DocumentIcon } from '@heroicons/react/24/outline';

const Pages: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Pages</h1>
      <p className="section-description">
        Manage website pages with flexible section-based content structure, including dynamic blocks and media management.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <DocumentIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Page Management</h3>
              <p className="feature-description">
                Handle pages with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit pages with dynamic sections</li>
                <li>Manage page title and URL slug</li>
                <li>Delete individual pages</li>
                <li>Bulk delete multiple pages</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Section Management</h3>
              <p className="feature-description">
                Organize page content with flexible sections:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Hero sections</li>
                <li>About sections</li>
                <li>Gallery sections</li>
                <li>FAQ sections</li>
                <li>Reorder and duplicate sections</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Block Management</h3>
              <p className="feature-description">
                Customize sections with various content blocks:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Text blocks with rich formatting</li>
                <li>Image blocks with upload support</li>
                <li>Video blocks</li>
                <li>Button blocks with link options</li>
                <li>Grid layout support (2 columns)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <DocumentIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Page List</h3>
              <p className="feature-description">
                View and manage pages in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Title (searchable)</li>
                <li>URL slug (searchable)</li>
                <li>Creation date (sortable)</li>
                <li>Last update date (sortable)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Use clear, descriptive page titles</li>
            <li>Create SEO-friendly URL slugs</li>
            <li>Organize content logically with appropriate sections</li>
            <li>Use high-quality images optimized for web</li>
            <li>Maintain consistent section structure across pages</li>
            <li>Regularly review and update page content</li>
            <li>Test page layout and responsiveness</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Pages; 